class BeeMap {

   constructor(containerId, markers, style = 'style-1', options) {
      this.containerId = containerId;
      this.markers = markers;
      this.style = style;
      this.options = options;

      this.init();
   }

   init = () => {
      
      this.renderMap();

   }

   addMarker = (marker, map) => {
      const latLng = L.latLng(marker?.lat, marker?.lng);
      const icon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='63.64' height='84.632' viewBox='0 0 63.64 84.632'%3E%3Cdefs%3E%3CclipPath id='clip-path'%3E%3Crect id='Rettangolo_179' data-name='Rettangolo 179' width='63.64' height='84.632' transform='translate(0 0)' fill='none'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg id='Raggruppa_267' data-name='Raggruppa 267' transform='translate(0 0)'%3E%3Cg id='Raggruppa_266' data-name='Raggruppa 266' clip-path='url(%23clip-path)'%3E%3Cpath id='Tracciato_384' data-name='Tracciato 384' d='M27.892,1.9C19.392,12.542,0,38.33,0,52.814a31.82,31.82,0,0,0,63.64,0C63.64,38.33,44.249,12.542,35.748,1.9a5.007,5.007,0,0,0-7.856,0' fill='%23186891'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A";

      const markerObject = L.marker(latLng, {
         icon: L.icon({
            iconUrl: icon,
            iconSize: [28, 37],
            iconAnchor: [14, 37],
            popupAnchor: [0, -37],
         })
      });

      const htmlContent = `
      <div class="infowindow-content">
         <h4 class="infowindow-title text-primary h3">${marker?.popup__title}</h4>
         <div class="infowindow-address">
            ${marker?.popup__caption}
         </div>
      </div>
      `;

      markerObject.bindPopup(htmlContent);

      markerObject.addTo(map);
   }

   centerMap = (map) => {

      const _self = this;
      if ( _self.markers.length > 0 )
      {
         const coords = markers.map(function (marker)
         {
            return L.latLng(marker?.lat, marker?.lng)
         });

         let bounds = L.latLngBounds(coords);

         if (markers.length > 1)
         {
            map.fitBounds(bounds);
         } else
         {
            map.setView(bounds.getCenter(), this.options?.zoom || 13);
         }
      }
   }

   renderMap = () => {
      
      const _self = this;
      const container = document.getElementById(this.containerId);
      container.innerHTML = '';
      let providerUrl, maxZoom, attribution;

      switch( this.style )
      {
         case 'style-2':
            providerUrl = 'https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}';
            maxZoom = 19;
            attribution = '&copy;arcgisonline contributors';
         break;
         case 'style-3':
            providerUrl = 'https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}';
            maxZoom = 19;
            attribution = '&copy;arcgisonline contributors';
         break;
         case 'style-4':
            providerUrl = 'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png';
            maxZoom = 19;
            attribution = '&copy;CartoDB contributors';
         break;
         default:
            providerUrl = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
            maxZoom = 19;
            attribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
         break;
      }

      console.log('markers', this.markers);

      const tilesTemplate = L.tileLayer(providerUrl, {
         maxZoom: maxZoom,
         attribution: attribution
      });

      const map = L.map(container, {
         scrollWheelZoom: options?.scrollWheelZoom || false,
         zoomControl: options?.zoomControl || false
      });

      tilesTemplate.addTo(map);

      if( this.markers.length > 0 )
      {
         markers.forEach(function (marker)
         {
            _self.addMarker(marker, map);
         });
      }

      _self.centerMap( map );

   }

}